import { useTranslation } from "react-i18next";
import { ReportingFilters } from "@/components/patterns/reporting-filters";

export function CampaignFrame({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-full w-full min-w-0 flex-1 flex-col gap-[14px] px-6 pb-[22px] pt-[22px]">
      {children}
    </div>
  );
}

export function CampaignHeading() {
  const { t } = useTranslation("campaign");
  return (
    <div className="flex min-h-[60px] shrink-0 flex-wrap items-start justify-between gap-x-6 gap-y-3">
      <div className="min-w-0 flex-1 basis-[180px]">
        <h1 className="text-[24px] font-semibold leading-7 tracking-[-0.02em] text-ink">
          {t("list.title")}
        </h1>
        <p className="mt-1 text-xs text-muted-foreground">{t("list.subtitle")}</p>
      </div>
      <ReportingFilters />
    </div>
  );
}
